<template>
  <v-card v-if="show" height="100%" >
    <v-card-text class="d-flex justify-space-between">
      <h2 class="mt-2">{{ $t('workflow.minimap.title') }} </h2>
    </v-card-text>
    <v-list>
      <v-list-item-group>
            <v-list-item
              v-for="(item, index) in generateLevels"
              :key="index"
              class="list-minimap"
              :class="{ 'ghost': item.action.disableAction }"
            >
            <v-list-item-content class="list-minimap">
              <v-list-item-title class="list-minimap">
                <div class="list-row list-minimap">
                  <div class="actions-minimap">
                  <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }" class="list-minimap">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    @click="$emit('select', item.action)">mdi-pencil</v-icon>
                  </template>
                    <span> {{ $t("workflow.card_action.action.edit") }} {{item.id}}</span>
                  </v-tooltip>
                   <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }" class="list-minimap">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      color="gray"
                      class="ml-2"
                      @click="$emit('redirect-owner', item.action)">mdi mdi-share</v-icon>
                    </template>
                      <span> {{ $t("workflow.minimap.open_action_location") }} </span>
                    </v-tooltip>
                    <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }" class="list-minimap">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      color="orange"
                      class="ml-2"
                      :style="needShowRedirect(item.action)"
                      @click="$emit('redirect', item.action)">mdi-format-text-wrapping-overflow</v-icon>
                    </template>
                      <span>{{ $t("workflow.minimap.open_action_alternative_flow") }}</span>
                    </v-tooltip>
                  </div>
                  <v-icon class="list-minimap" :style="getArrow(item.level)">mdi-arrow-right</v-icon>
                  <div>
                    <v-tooltip top>
                          <template v-slot:activator="{ on }">
                          <div class="disabled-desc">
                            <span  v-if="item.action.disableAction" class="subtitle-2 red--text"> <v-icon v-on="on"  color="red" small > mdi-block-helper </v-icon></span>
                          </div>
                          </template>
                      <span>{{$t('workflow.minimap.disabled')}}</span>
                      </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }" class="list-minimap">
                        <p
                          v-bind="attrs"
                          v-on="on"
                          class="list-minimap bold">
                          {{item.action.actionName}}
                        </p>

                        <p class = "ghost"
                          v-bind="attrs"
                          v-on="on"
                          >
                          {{resumeActionName(item.action.actionType)}}
                        </p>
                      </template>
                      <span>{{ extractActionDescription(item.action)}}</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'WorkFlowMinimap',

  props: ['workflow', 'show'],

  model: {
    prop: 'workflow',
    event: 'change'
  },
  created () {
    this.loadGenerateLevels()
    // setInterval(() => { this.$forceUpdate() }, 100)
  },

  data () {
    return {
      subLevelActions: [
        'br.com.senior.plutaoapp.workflow.actions.IfAction',
        'br.com.senior.plutaoapp.workflow.actions.ForAction',
        'br.com.senior.plutaoapp.workflow.actions.ForMapAction',
        'br.com.senior.plutaoapp.workflow.actions.TryCatchAction'
      ],
      workflowDesc: null,
      generateLevels: []
    }
  },

  computed: {
    ...mapState(['avaliableActions'])
  },
  watch: {
    workflow: {
      handler: function (val, oldVal) {
        this.loadGenerateLevels()
      },
      deep: true
    }
  },

  methods: {
    loadGenerateLevels () {
      if (this.workflow && this.workflow.actions) {
        this.generateLevels = this.extractActions(this.workflow.actions, 0, null)
      } else {
        this.generateLevels = []
      }
      return 0
    },
    extractActions (act, level, list) {
      let actionList = list == null ? [] : list
      for (let i = 0; i < act.length; i++) {
        const action = act[i]
        actionList.push({
          id: actionList.length,
          action: action,
          level: level
        })

        if (this.subLevelActions.indexOf(action.actionType) >= 0) {
          actionList = this.extractActions(action.actions, level + 1, actionList)
        }
      }
      return actionList
    },

    resumeActionName (fullActionName) {
      if (!fullActionName) return ''
      const split = fullActionName.split('.')
      return split[split.length - 1]
    },

    getArrow (level) {
      if (level === 0) {
        return 'display: none'
      }
      const margin = level * 20
      return 'margin-left:' + margin + 'px'
    },

    extractActionDescription (action) {
      if (action.actionDescription) {
        return action.actionDescription
      }
      return action.actionName
    },

    needShowRedirect (action) {
      const hide = 'display: none;'
      if (this.subLevelActions.indexOf(action.actionType) >= 0) {
        return ''
      }
      return hide
    }
  }
}
</script>

<style scoped>
.list-row {
  display: flex;
  flex-direction: row;
  justify-content: initial;
  align-items: center;
}

.list-row p{
  margin: 0 0 0 10px;
  font-size: 12px;
}

.list-row:hover{
  cursor:auto;
}

.list-minimap:hover {
  cursor:auto;
}

.actions-minimap {
  width: 90px;
}

.bold{
  font-weight: bold;
}

.ghost {
  opacity: 0.7;
}
.disabled-desc{
    position: absolute;
    right: 0;
    padding-right: 50px;
}

</style>
